import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { T, IMAGES } from "@/content/site";

const rise = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 1, ease: [0.19, 1, 0.22, 1] } },
};

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="philosophy" data-testid="philosophy-section" className="relative bg-[#0F0F0F] pt-[140px] md:pt-[200px] pb-[160px]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={rise}
          className="overline mb-8"
        >
          <span className="inline-block w-8 h-px bg-[color:var(--sacrvm-gold)] align-middle mr-3" />
          {t(T.philosophy.overline)}
        </motion.div>

        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={rise}
          className="font-serif text-white text-[40px] sm:text-[56px] md:text-[80px] leading-[1] tracking-[-0.01em] max-w-[1100px]"
        >
          {t(T.philosophy.title)}
        </motion.h2>

        <motion.p
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={rise}
          transition={{ delay: 0.1 }}
          className="mt-8 text-[color:var(--sacrvm-text-muted)] text-[18px] md:text-[22px] font-serif italic max-w-[720px] leading-[1.4]"
        >
          {t(T.philosophy.subtitle)}
        </motion.p>

        <div className="mt-24 md:mt-32 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5 md:sticky md:top-32 self-start">
            <div className="img-hover">
              <img
                src="https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/sz66a4go_images%20%284%29.jpg"
                alt="Maestros mezcaleros SACRVM"
                className="w-full h-[480px] md:h-[620px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="mt-6 flex items-center gap-4 text-[11px] tracking-[0.28em] uppercase text-white/50">
              <span className="w-6 h-px bg-white/30" />
              Fig. I — Maestros mezcaleros
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-8">
            {T.philosophy.chapters.map((c, i) => (
              <motion.article
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.05, ease: [0.19, 1, 0.22, 1] }}
                className="relative py-10 md:py-14 border-t border-white/10 first:border-t-0"
              >
                <div className="flex items-baseline gap-6 md:gap-10">
                  <div className="font-serif text-[color:var(--sacrvm-gold)] text-[22px] md:text-[28px] tracking-[0.1em] w-16 shrink-0">
                    {c.n}
                  </div>
                  <div>
                    <h3 className="font-serif text-white text-[28px] md:text-[38px] leading-[1.1]">
                      {t(c.title)}
                    </h3>
                    <p className="mt-4 text-[color:var(--sacrvm-text-muted)] text-[16px] md:text-[17px] leading-[1.7] max-w-[560px]">
                      {t(c.body)}
                    </p>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
